module.exports = __webpack_public_path__ + "img/3.662d6bd6.png";